import { render } from "./UserProfileModal.vue?vue&type=template&id=7d07de12"
import script from "./UserProfileModal.vue?vue&type=script&lang=ts"
export * from "./UserProfileModal.vue?vue&type=script&lang=ts"
script.render = render

export default script